import { FC } from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { Link } from '@vs-online-only-app/ui';

type Props = {
  title: string;
};

const ProfileSetupError: FC<Props> = ({ title }) => (
  <Alert severity="error">
    <AlertTitle>Unable to update your {title}</AlertTitle>
    Please try again. If the problem persists, please{' '}
    <Link to="mailto:support-chat@bambuser.com">contact customer care.</Link>
  </Alert>
);

export default ProfileSetupError;
